import { useMutation } from "react-query";
import _ from "lodash";
import { FC } from "react";
import { DeleteButton } from "../../common/components/DeleteButton";
import { fetchDeleteTaskSubmission } from "../miscellaneous/fetchDeleteTaskSubmission";

type DeleteTaskSubmisstionProps = {
  id: string;
  info: string;
  taskSubmission: any;
  setTaskSubmission: any;
  setTotalRecords: React.Dispatch<React.SetStateAction<number>>;
};

export const DeleteTaskSubmission: FC<DeleteTaskSubmisstionProps> = ({
  id,
  info,
  taskSubmission,
  setTaskSubmission,
  setTotalRecords,
}) => {
  const mutationDelete = useMutation(fetchDeleteTaskSubmission, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const tasksFilter = _.filter(taskSubmission, (item) => {
          return item.id !== id;
        });
        setTaskSubmission(tasksFilter);
        setTotalRecords((prev) => prev - 1);
      }
    },
    onError: () => {},
  });

  const handleDelete = (event: any) => {
    event.stopPropagation();
    mutationDelete.mutate(id);
  };

  return (
    <DeleteButton
      id={id}
      title={"Delete Task"}
      info={info}
      customContent={"Are you sure that you want to delete this task?"}
      onHandleDelete={handleDelete}
    />
  );
};
